'use client';
import { useTranslations } from 'next-intl';

import BoxIcon from '@/fo/icons/base/icons/box.svg';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { UiKitProgressLine } from '@/fo/ui/kit/progress/line';

import { styles } from './UiDeliveryInformerBase.styles';

export interface UiDeliveryInformerBaseProps {
  className?: string;
  subtotalPrice: number;
  leftAmount: number;
  currency?: string;
  title?: string;
  deliveryCity?: string;
  minDeliveryTime?: string;
  deliveryOptions?: Array<{
    label: string;
    time?: string | null;
    price: number;
  }>;
}

export function UiDeliveryInformerBase({
  className,
  subtotalPrice,
  leftAmount,
  currency,
  title
}: UiDeliveryInformerBaseProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base({ className })}>
      {title && <p className={slots.title()}>{title}</p>}
      <div className={slots.text()}>
        {!!leftAmount && (
          <>
            <BoxIcon />
            {t('Free shipping is still available')}
            <span className={slots.amount()}>
              <UiKitPriceBase
                value={leftAmount}
                currency={currency}
              />
            </span>
          </>
        )}
      </div>

      <UiKitProgressLine
        className={slots.line()}
        current={subtotalPrice}
        target={subtotalPrice + leftAmount}
      />
    </div>
  );
}
